import { Injectable } from '@angular/core';
import { StandardProcessService } from '../DefineService/standardProcess-service';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DownloadHelperService {

  constructor(public standardProcessService: StandardProcessService) { }

  showDownloadDocument($event: any, getFileUploadStandardProcessArray:any ){
    let extension = $event.fileName.split('.').pop();
    for (let i = 0; i < getFileUploadStandardProcessArray.length; i++) {
      
      if ($event.index == i) {
        const pdfTable = getFileUploadStandardProcessArray[i].qfs_url;
        let splitedbase64 = pdfTable.split(',')[1];
        if ($event.type == 'download') {
          if (extension == 'pdf') {
            const source = `data:application/pdf;base64,${splitedbase64}`;
            const link = document.createElement("a");
            link.href = source;
            link.download = `${$event.fileName}.pdf`
            link.click();
          }
          else if (extension == 'doc' || extension == 'docx') {
            let source =
              'data:application/msword;base64,' +
              splitedbase64;
            let fileDownload = document.createElement('a');
            document.body.appendChild(fileDownload);
            fileDownload.href = source;
            fileDownload.download = `${$event.fileName}.doc`;
            fileDownload.click();
          }
        } else {
          if (extension == 'pdf') {
            var byteCharacters = atob(splitedbase64);
            var byteNumbers = new Array(byteCharacters.length);
            for (i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var file = new Blob([byteArray], { type: 'application/pdf;base64' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          }
        }
        break;
      }
    } 
  }

  async GetViewDownloadedDocument(facilityKey: any, type: any, pageTittleName: any) {
    return this.standardProcessService.GetFileUploadStandardProcess(facilityKey, type, pageTittleName.split(' ')[0])
      .pipe(
        map(async (res:any) => this.prepareDownloadedDocuments(res?.data)),
        catchError(error => {
          console.error('Error fetching documents:', error);
          return throwError(error);
        })
      );
  }
  
  private prepareDownloadedDocuments(data: any[]): any[] {
    return data.map((item) => {
      item.qfs_uploadedDocument = item.qfs_uploadedDocument.replace(/PreVSM/gi, 'Pre VSM'); // Replace all occurrences
      item.qfs_uploadedDocument = item.qfs_uploadedDocument.replace(/StandardProcess/gi, 'Standard Process');
  
      if (item.qfs_url.split(',')[0].toString().startsWith('data:application/msword;base64') ||
          item.qfs_url.split(',')[0].toString().startsWith('data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64')) {
        item.wordFileDnone = 'display: none;';
      } else {
        item.wordFileDnone = 'display: inline-flex;';
      }
      return item;
    });
  }
  SlidePrePostImplementation(direction:string, type:string){
    let container:any = document.getElementById(type);
    let scrollCompleted = 0;
    let slideVar = setInterval(function(){
        if(direction == 'left'){
            container.scrollLeft += 10;
        } else {
            container.scrollLeft -= 10;
        }
        scrollCompleted += 10;
        if(scrollCompleted >= 100){
            window.clearInterval(slideVar);
        }
    }, 50);
}
  
}
